import { LegislationKey } from '@core/domain/legislation'

const materialMixtureCategoryLegislationKeys = [
    LegislationKey.FCM,
    LegislationKey.PPWR,
]

export default {
    methods: {
        hasMaterialMixtureCategoryLegislation(legislations, { requireApplicable = false } = {}) {
            if (!legislations) {
                return false
            }

            return Object.values(legislations).some(legislation => {
                if (!materialMixtureCategoryLegislationKeys.includes(legislation.key)) {
                    return false
                }

                return !requireApplicable || legislation.isApplicable
            })
        },
    },
}
